import { Button, Stack, Text, Title } from "@mantine/core";

import { WarningIcon } from "../../components/WarningIcon/WarningIcon";

interface CheckInStepWarningProps {
  onNextStep: () => void;
}

export function CheckInStepWarning({ onNextStep }: CheckInStepWarningProps) {
  return (
    <>
      <Stack align="center" justify="center">
        <WarningIcon size={32} />

        <Title order={2}>Atenção</Title>
      </Stack>

      <Stack mb="sm" gap="md" className="text-center!">
        <Text size="md" ta="center" className="font-semibold!">
          Está ação tem como objetivo facilitar a organização física dos veículos presentes respeitando a sequência da fila geral, ou seja, é um filtro para organizar o fluxo de
          chamada dos veículos.
        </Text>

        <Text ta="justify">
          O check-in está disponível exclusivamente para veículos no pátio, caso a ação seja realizada e o motorista se ausente da indústria, será necessário refazer o check-in.
        </Text>

        <Text ta="justify">Esta ação não cancela/altera o tempo de tolerância do veículo, logo seguimos recomendando a chegada com 6 horas de antecedência.</Text>
      </Stack>

      <Button onClick={onNextStep} fullWidth>
        continuar
      </Button>
    </>
  );
}
